
import { toast } from "sonner";

const FUNCTION_URL = "https://nzbrwnqbsdtxyaifmvcn.supabase.co/functions/v1/generate-legal-document";

export interface GenerationResponse {
  success: boolean;
  content: string;
  error?: string;
}

export async function generateLegalDocument(userInput: string, language = 'ur'): Promise<GenerationResponse> {
  try {
    // Track generation count
    const currentCount = parseInt(localStorage.getItem('adaaltBotGeneratedCount') || '0');
    localStorage.setItem('adaaltBotGeneratedCount', (currentCount + 1).toString());
    
    const response = await fetch(FUNCTION_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        userInput,
        language
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error("API Error:", errorData);
      throw new Error(errorData.error || (language === 'ur' ? "API خرابی، براہ کرم دوبارہ کوشش کریں" : "API error, please try again"));
    }

    const data = await response.json();
    
    if (!data.success) {
      throw new Error(data.error || (language === 'ur' ? "کوئی نتیجہ نہیں ملا" : "No result found"));
    }

    return {
      success: true,
      content: data.content
    };
  } catch (error) {
    console.error("Generation error:", error);
    const errorMessage = error instanceof Error ? error.message : (language === 'ur' ? "نامعلوم خرابی" : "Unknown error");
    toast.error(errorMessage);
    return {
      success: false,
      content: "",
      error: errorMessage
    };
  }
}
